import {
  GESTION_OPERATIVA_GET_COTIZACION,
  GESTION_OPERATIVA_GET_COTIZACION_DISMISS_ERROR,
} from '../constants'
    
export function getCotizacion(params) {
  return (dispatch) => {
      dispatch({
        type: GESTION_OPERATIVA_GET_COTIZACION,
        data: {params}
      })
    }
  }

  export function dismissGetCotizacionError() {
    return {
      type: GESTION_OPERATIVA_GET_COTIZACION_DISMISS_ERROR,
    }
}